import { Timestamp } from '../firebase/firebaseAccess';
import { apiServerTimeToAppDate } from './apiServerTimeToAppDate';

/**
 * @param time
 */
export function apiServerTimeToDateObject(time: string | Timestamp): Date {
  return apiServerTimeToAppDate(time).toDate();
}
